import React from "react";

// Feature Cards Data
const features = [
  {
    id: 1,
    icon: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6 text-[#2871d3]"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
    ),
    title: "20+ Years of Experience",
    description:
      "Helping 40M+ travelers worldwide Partnered with 1M+ verified hotels",
  },
  {
    id: 2,
    icon: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6 text-[#2871d3]"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
        <path d="M19 8h-2c0-2.76-2.24-5-5-5V1c3.86 0 7 3.14 7 7zm-4 0h-2c0-1.1-.9-2-2-2V4c2.21 0 4 1.79 4 4z" />
      </svg>
    ),
    title: "24/7 Travel Advisors",
    description: "Personalized planning and real human support, anytime",
  },
  {
    id: 3,
    icon: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6 text-[#2871d3]"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" />
      </svg>
    ),
    title: "Upfront Pricing",
    description: "Our prices include taxes and fees",
  },
  {
    id: 4,
    icon: (
      <svg
        className="w-5 h-5 sm:w-6 sm:h-6 text-[#2871d3]"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.41l9 9c.36.36.86.59 1.41.59s1.05-.22 1.41-.59l7-7c.36-.36.59-.86.59-1.41s-.23-1.05-.59-1.41zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          d="M12 16l4-4"
        />
      </svg>
    ),
    title: "Members Save More",
    description: "Join ClubMiles rewards program and save on every booking",
  },
];

const TravelFeatures = () => {
  return (
    <div className="font-sans">
      {/* --- TOP BANNER SECTION --- */}
      <section className="mx-auto max-w-7xl bg-white px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center rounded-[2rem] border border-slate-200 bg-white shadow-[0_18px_45px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_24px_60px_rgba(40,113,211,0.12)] lg:flex-row lg:rounded-full lg:pr-8">
          {/* Image & Avatar Container */}
          <div className="relative w-full lg:w-[320px] xl:w-[380px] h-48 lg:h-[130px] shrink-0">
            {/* Main Landscape Image */}
            <img
              src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=1000&auto=format&fit=crop"
              alt="People kayaking in clear water"
              className="w-full h-full object-cover rounded-t-[2rem] lg:rounded-t-none lg:rounded-l-full"
            />
            {/* Overlapping Avatar Profile */}
            <div className="absolute bottom-0 left-1/2 z-10 flex h-20 w-20 translate-y-1/2 -translate-x-1/2 transform items-center justify-center overflow-hidden rounded-full border-[5px] border-white bg-blue-50 shadow-sm sm:h-24 sm:w-24 sm:border-[6px] lg:left-full lg:top-1/2 lg:translate-y-0 lg:-translate-y-1/2">
              <img
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop"
                alt="Travel Expert"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="pt-14 sm:pt-16 lg:pt-0 lg:pl-[4.5rem] px-6 lg:px-0 text-center lg:text-left flex-1 pb-6 lg:pb-0">
            <h2 className="text-[19px] sm:text-[22px] font-extrabold text-slate-900 tracking-tight">
              Your trip. Designed by our 24/7 travel experts
            </h2>
            <p className="text-xs sm:text-sm text-slate-500 mt-2 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Enjoy personalized planning with real human support. Call Our
              Travel Experts 24/7. Call{" "}
              <strong className="text-slate-900">1-888-977-1997</strong> and say{" "}
              <strong className="text-emerald-600">HELLO50</strong> to save.
              <svg
                className="inline-block w-3.5 h-3.5 text-slate-400 ml-1 cursor-help hover:text-slate-700 transition-colors"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </p>
          </div>

          {/* Call to Action Button */}
          <div className="pb-8 lg:pb-0 px-6 lg:px-0 w-full lg:w-auto shrink-0 flex justify-center lg:justify-end">
            <button className="w-full whitespace-nowrap rounded-full bg-[#2871d3] px-8 py-3.5 text-sm font-bold text-white shadow-md transition-all hover:bg-[#155bc2] hover:shadow-lg hover:shadow-blue-600/25 active:scale-95 sm:text-base lg:w-auto lg:py-3">
              Call us
            </button>
          </div>
        </div>
      </section>

      {/* --- FEATURES GRID SECTION --- */}
      <section className="border-t border-slate-100 bg-[#f8f9fc] px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="mb-6 text-center text-[22px] font-black tracking-tight text-slate-950 sm:mb-10 sm:text-[32px] lg:text-left">
            What travelers love about TripReserver
          </h2>

          {/* Mobile: 1 col (horizontal cards) | Tablet: 2 col | Desktop: 4 col (vertical cards) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="group flex flex-row items-start rounded-[1.4rem] border border-slate-200/70 bg-white p-5 text-left shadow-[0_12px_30px_rgba(15,23,42,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-blue-100 hover:shadow-[0_18px_45px_rgba(40,113,211,0.1)] sm:flex-col sm:items-center sm:p-8 sm:text-center"
              >
                {/* Icon Circle */}
                <div className="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-50 transition-transform duration-300 group-hover:scale-110 group-hover:bg-blue-100 sm:mr-0 sm:mb-5 sm:h-12 sm:w-12">
                  {feature.icon}
                </div>

                {/* Feature Text */}
                <div className="flex-1 mt-0.5 sm:mt-0">
                  <h3 className="text-[15px] sm:text-base font-bold text-slate-900 mb-1 sm:mb-2.5">
                    {feature.title}
                  </h3>
                  <p className="text-[13px] sm:text-sm text-slate-500 font-medium leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TravelFeatures;
